export const DEFAULT_RULE_FILE_PATH: string = "rule.yaml";
